import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import { Table, Button, Form } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "../../../data/applicationSlice"
import { getNamedInsuredRelationships } from "../../../data/enumSlice"
import { byPrefixAndName } from "@awesome.me/kit-de80aecb6a/icons"

const { updateApplicationData } = actions

const RequestedAdditionalNamedInsureds = ({ questionNumber }) => {
    const [limitsData, setLimitsData] = useState([])
    const dispatch = useDispatch()
    const { additionalNamedInsureds, fetchStatus, application } = useSelector((state) => state.application)
    const { namedInsuredRelationships } = useSelector((state) => state.enums)

    useEffect(() => {
        const insuredType = additionalNamedInsureds?.filter((insured) => insured.type === "AdditionalNamedInsured")

        if (insuredType?.length) {
            setLimitsData(insuredType)
        } else {
            const initialData = {
                localId: Math.random().toString(36).substr(2, 9),
                name: "",
                relationship: "",
                relationshipOther: "",
                id: "00000000-0000-0000-0000-000000000000",
                applicationId: "00000000-0000-0000-0000-000000000000",
                type: "AdditionalNamedInsured"
            }
            setLimitsData([initialData])
            let newData = [...(additionalNamedInsureds || [])]
            newData.push(initialData)
            dispatch(updateApplicationData({ field: "additionalNamedInsureds", value: newData }))
        }
    }, [fetchStatus, additionalNamedInsureds])

    useEffect(() => {
        !namedInsuredRelationships?.length && dispatch(getNamedInsuredRelationships())
    }, [])

    const handleAddRow = () => {
        const newData = [...(additionalNamedInsureds || [])]
        newData.push({
            localId: Math.random().toString(36).substr(2, 9),
            name: "",
            relationship: "",
            id: "00000000-0000-0000-0000-000000000000",
            applicationId: "00000000-0000-0000-0000-000000000000",
            type: "AdditionalNamedInsured"
        })
        setLimitsData(newData.filter((item) => item.type === "AdditionalNamedInsured"))
        dispatch(
            updateApplicationData({
                field: "additionalNamedInsureds",
                value: newData
            })
        )
    }

    const handleDeleteRow = (localId) => {
        if (limitsData.length > 1) {
            const newData = additionalNamedInsureds?.filter((item) => item.localId !== localId)

            const limitsDateNew = limitsData.filter((item) => item.localId !== localId)

            setLimitsData(limitsDateNew)

            dispatch(
                updateApplicationData({
                    field: "additionalNamedInsureds",
                    value: newData
                })
            )
        }
    }

    const handleInputChange = (field, value, localId) => {
        const newData = additionalNamedInsureds?.map((item) => {
            if (item.localId === localId) {
                return {
                    ...item,
                    [field]: value
                }
            }
            return item
        })
        dispatch(
            updateApplicationData({
                field: "additionalNamedInsureds",
                value: newData
            })
        )

        const limitsDateNew = limitsData.map((item) => {
            if (item.localId === localId) {
                return {
                    ...item,
                    [field]: value
                }
            }
            return item
        })

        setLimitsData(limitsDateNew)
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center my-2">
                <h6>
                    {questionNumber}. Please list any requested additional <strong>named insureds</strong> for the
                    proposed coverage.
                </h6>
                {limitsData.length < 5 && (
                    <Button
                        className="btn-sm"
                        variant="light"
                        onClick={handleAddRow}>
                        Add
                    </Button>
                )}
            </div>
            <Table
                striped
                bordered
                hover
                responsive>
                <thead>
                    <tr>
                        <th>Additional Named Insured</th>
                        <th>Relationship to First Named Insured</th>
                        <th style={{ width: "80px" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {limitsData.map((item, index) => (
                        <tr key={index}>
                            <td>
                                <Form.Control
                                    type="text"
                                    className="form-control-sm"
                                    value={item.name || ""}
                                    onChange={(e) => handleInputChange("name", e.target.value, item.localId)}
                                />
                            </td>
                            <td>
                                <Form.Select
                                    className="form-select-sm"
                                    value={item?.relationship || ""}
                                    onChange={(e) => handleInputChange("relationship", e.target.value, item.localId)}>
                                    <option value={""}>--- Select ---</option>
                                    {namedInsuredRelationships?.map((namedInsuredRelationship) => (
                                        <option
                                            key={namedInsuredRelationship?.value}
                                            value={namedInsuredRelationship?.value}>
                                            {namedInsuredRelationship?.name}
                                        </option>
                                    ))}
                                </Form.Select>

                                {item?.relationship === "other" && (
                                    <Form.Control
                                        type="text"
                                        className="form-control-sm other"
                                        value={item?.other || ""}
                                        onChange={(e) =>
                                            handleInputChange("relationshipOther", e.target.value, item.localId)
                                        }
                                    />
                                )}
                            </td>
                            <td className="align-text-center">
                                {limitsData.length > 1 && (
                                    <FontAwesomeIcon
                                        icon={byPrefixAndName.fal["trash"]}
                                        style={{ color: "#C50000" }}
                                        className="clickable-icon icon-red"
                                        onClick={() => handleDeleteRow(item.localId)}
                                    />
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <div>
                Additional Named Insureds will be limited to related entities whose services, revenues and all other
                representations are included in this application.
            </div>
        </>
    )
}

export default RequestedAdditionalNamedInsureds
